import { connect } from 'react-redux';
import { getThreadState } from '../../selectors';
const mapStateToProps = (state, { commentableItemId , commentableTypeId , parentId  })=>{
    const { total  } = getThreadState(state, commentableTypeId, commentableItemId, parentId);
    return {
        total
    };
};
export default connect(mapStateToProps);
